import { Button } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const EditCell = ({ row, table }) => {
  const meta = table.options.meta;

  const setEditing = (value) => {
    console.log("EditCell/setEditing", value);
    if (value === null) {
      meta?.setSubEventsListData?.(prev => ({
        ...prev,
        isOpen: false,
        visibleSubEvents: [],
        onSelectEvent: null
      }));
    }
    meta?.setEditingEventId(value);
  };
  const save = (e) => {
    setEditing(null);
    meta?.updateEvent(row.original.id);
  };
  const preview = (e) => {
    meta?.setPreviewEventId((old) => (old ? null : row.original.id));
  };
  const remove = (e) => {
    meta?.deleteEvent(row.original.id);
  };

  return meta?.editingId == row.original.id ? (
    <>
      <div className="d-flex gap-1">
        <Button
          className="edit-cell-action-button"
          variant="secondary"
          size="sm"
          onClick={preview}
        >
          <FontAwesomeIcon
            icon={["fas", meta?.previewEventId === null ? "eye" : "eye-slash"]}
            size="sm"
          />
        </Button>
        <Button
          className="edit-cell-action-button"
          variant="success"
          onClick={save}
          size="sm"
        >
          <FontAwesomeIcon icon={["fas", "check"]} size="sm" />
        </Button>
        <Button
          className="edit-cell-action-button"
          variant="danger"
          size="sm"
          onClick={() => setEditing(null)}
        >
          <FontAwesomeIcon icon={["fas", "xmark"]} size="sm" />
        </Button>
      </div>
    </>
  ) : (
    <div className="d-flex gap-1">
      <Button
        className="edit-cell-action-button"
        onClick={() => {
          console.log("EditCell/onClick", row.original.id);
          setEditing(row.original.id)
        }}
        variant="secondary"
        size="sm"
      >
        <FontAwesomeIcon icon={["fas", "pen"]} size="sm" />
      </Button>
      <Button
        className="edit-cell-action-button"
        onClick={remove}
        variant="danger"
        size="sm"
      >
        <FontAwesomeIcon icon={["fas", "trash"]} size="sm" />
      </Button>
    </div>
  );
};

export default EditCell;
